<template>
    <ModalBase
        name="crear-sesion"
        :title="'Crear nueva sesión para el evento: ' + evento.nombre_completo"
        @close="close(false)"
    >
        <template v-if="!loading">
            <ValidationObserver ref="observer" tag="form" @submit.prevent="submit">
                <FormSesion
                    :form="form"
                    :loading="loading"
                    :min-fecha-inicio="minFechaInicio"
                    :max-fecha-inicio="maxFechaInicio"
                    :min-fecha-fin="minFechaFin"
                    :max-fecha-fin="maxFechaFin"
                    :rango-sesion="rangoSesion"
                    :aviso-rango-fechas="avisoRangoFechas"
                    :puede-editar-cierre-venta="puedeEditarCierreVenta"
                    :mostrar-fecha-provisional="mostrarFechaProvisional"
                    @update:fecha-inicio="form.fecha_inicio = $event"
                    @update:fecha-fin="form.fecha_fin = $event"
                    @update:fecha-cierre-venta="form.fecha_cierre_venta = $event"
                    @update:fecha-provisional="form.fecha_provisional = $event"
                    @update:text="form.text = $event"
                    @update:apertura="form.apertura_puertas = $event"
                />
            </ValidationObserver>
        </template>
        <template v-else>
            <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:py-12">
                <LoaderComponent/>
                <h3
                    v-if="evento && evento.cerrar_butacas_abonados == 1"
                    class="tw:text-base tw:font-medium tw:text-gray-700"
                >
                    Cerrando butacas de los abonados...
                </h3>
            </div>
        </template>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button
                    id="crear-sesion"
                    data-cy="crear-sesion"
                    :loading="loading"
                    :disabled="loading"
                    @click="submit"
                >
                    Crear
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import FormSesion from '@/components/backend/eventos/sesiones/FormSesion.vue';
    import { useSesionForm } from '@/composables/admin/eventos/useSesionForm';

    const props = defineProps({
        evento: {
            type: Object,
            required: true,
        },
    });

    const emit = defineEmits(['close']);

    const observer = ref(null);

    const {
        form,
        loading,
        minFechaInicio,
        maxFechaInicio,
        minFechaFin,
        maxFechaFin,
        rangoSesion,
        avisoRangoFechas,
        puedeEditarCierreVenta,
        mostrarFechaProvisional,
        submitSesion,
    } = useSesionForm({ evento: props.evento, mode: 'crear' });

    const close = creado => {
        emit('close', 'crear-sesion', creado);
    };

    const submit = async() => {
        const isValid = await observer.value.validate();
        if (!isValid) return;

        const ok = await submitSesion();
        if (ok) close(true);
    };
</script>
